import React, { useMemo } from 'react';
import { Content, Progress } from '@backstage/core-components';
import { Typography } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { getApiErrorMessage } from '../../../shared/api/getApiErrorMessage';
import { BackToRoles } from '../components/RoleDetails/BackToRoles';
import { mapApiRoleToDetails } from '../components/RoleDetails/mapApiRole';
import { RoleDetails } from '../components/RoleDetails/RoleDetails';
import { useRole } from '../components/RoleDetails/useRole';
import { isRoleCategory } from '../components/RoleDetails/types';

export default function RoleDetailsPage() {
  const { roleCategory, roleId } = useParams();
  const roleQuery = useRole(roleId);
  const roleDetails = useMemo(
    () => (roleQuery.data ? mapApiRoleToDetails(roleQuery.data) : undefined),
    [roleQuery.data],
  );

  if (roleQuery.isPending) {
    return (
      <Content>
        <BackToRoles
          roleCategory={isRoleCategory(roleCategory) ? roleCategory : undefined}
        />
        <Progress />
      </Content>
    );
  }

  if (roleQuery.isError || !roleDetails) {
    return (
      <Content>
        <BackToRoles
          roleCategory={isRoleCategory(roleCategory) ? roleCategory : undefined}
        />
        <Typography>
          {getApiErrorMessage(roleQuery.error, 'Role not found')}
        </Typography>
      </Content>
    );
  }

  return (
    <Content>
      <RoleDetails
        key={`${roleDetails.category}:${roleDetails.id}`}
        roleDetails={roleDetails}
      />
    </Content>
  );
}
